import { EMPTY_STRING } from '../../React/Common/Constants/Separators'
import { IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
/** Unicode symbol for unit separator: unlikely in user-visible admin list fields, safe for joining key segments. */
const ADMIN_LIST_ROW_KEY_SEGMENT_SEP: string = '\u241f'

/**
 * <p>Builds a React {@link Key} for admin data-table rows that is unique per row in a paginated response, while
 * keeping as much payload identity as practical for reconciliation.</p>
 *
 * <p>Natural keys such as {@code DeviceNumber} or {@code TelephoneNumber} are not always unique within one page;
 * appending the absolute row index ({@code pageStartIndex + index}) guarantees uniqueness without requiring API
 * changes.</p>
 *
 * @param identitySegments - Values from the row (and optional scope ids) used to stabilise the key when the same
 * logical row appears after refresh.
 * @param pageStartIndex - Zero-based offset of the first row on this page (typically {@code currentPage * rowsPerPage}).
 * @param index - Zero-based index of the row within the current page slice.
 * @returns A string suitable for {@code DataTable} row {@code key} props.
 */
export function buildAdminListRowKey(
    identitySegments: readonly Definable<Nullable<string | number>>[],
    pageStartIndex: number,
    index: number
): string {
    const identity: string = identitySegments
        .map((s: Definable<Nullable<string | number>>): string => (IsVarEmpty(s) ? EMPTY_STRING : String(s)))
        .join(ADMIN_LIST_ROW_KEY_SEGMENT_SEP)

    return `${identity}${ADMIN_LIST_ROW_KEY_SEGMENT_SEP}${pageStartIndex + index}`
}
